import React from 'react';
import type { TtStats } from '../types';

type Props = {
  stats: TtStats | null;
};

const TtStatsDashboard: React.FC<Props> = ({ stats }) => {
  if (!stats) return null;

  const qrCount = stats.byMethod?.find(m => m.scanMethod === 'qr')?.count ?? 0;
  const ocrCount = stats.byMethod?.find(m => m.scanMethod === 'ocr')?.count ?? 0;
  const manualCount = stats.byMethod?.find(m => m.scanMethod === 'manual')?.count ?? 0;

  return (
    <div className="tt-stats">
      {/* Open courses */}
      <div className="tt-stats__card">
        <div className="tt-stats__icon tt-stats__icon--blue">
          <i className="material-icons">school</i>
        </div>
        <div className="tt-stats__value">{stats.openCourses}</div>
        <div className="tt-stats__label">Khóa đang mở</div>
        <div className="tt-stats__sub">
          <span className="tt-stats__sub-item">
            Tổng: {stats.totalCourses}
          </span>
        </div>
      </div>

      {/* Total records */}
      <div className="tt-stats__card">
        <div className="tt-stats__icon tt-stats__icon--green">
          <i className="material-icons">description</i>
        </div>
        <div className="tt-stats__value">{stats.totalRecords}</div>
        <div className="tt-stats__label">Tổng hồ sơ</div>
        <div className="tt-stats__sub">
          <span className="tt-stats__sub-item tt-stats__sub-item--badge">QR {qrCount}</span>
          <span className="tt-stats__sub-item tt-stats__sub-item--badge">OCR {ocrCount}</span>
        </div>
      </div>

      {/* Today */}
      <div className="tt-stats__card">
        <div className="tt-stats__icon tt-stats__icon--orange">
          <i className="material-icons">today</i>
        </div>
        <div className="tt-stats__value">{stats.recordsToday}</div>
        <div className="tt-stats__label">Nhập hôm nay</div>
        {stats.recordsToday > 0 && (
          <div className="tt-stats__sub">
            <span className="tt-stats__sub-item tt-stats__sub-item--up">
              <i className="material-icons">trending_up</i>
              +{stats.recordsToday}
            </span>
          </div>
        )}
      </div>

      {/* Methods */}
      <div className="tt-stats__card">
        <div className="tt-stats__icon tt-stats__icon--gray">
          <i className="material-icons">donut_small</i>
        </div>
        <div className="tt-stats__value">{stats.totalCourses}</div>
        <div className="tt-stats__label">Tổng khóa học</div>
        <div className="tt-stats__sub">
          <span className="tt-stats__sub-item">
            Thủ công: {manualCount}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TtStatsDashboard;
